//
//  I09DIMCIRCCalcul.js
//
//  Created by Sébastien Hecart on 2017-11-05 12:49:50 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

import { fetchMasseVolumiqueViscosite } from '@batical/data/src'
import { I09DIMCIRC_State } from '@batical/types/src'

function I09DIMCIRC_docalcul(state: I09DIMCIRC_State) {
  let selectedviscosite_uuid = fetchMasseVolumiqueViscosite(state.viscosite_uuid)

  var res_debitNecessaire = 0
  if (state.in_deltaK <= 0) {
    res_debitNecessaire = 0
  } else {
    res_debitNecessaire = (state.in_puissanceGenerateur * 3600) / (state.in_deltaK * selectedviscosite_uuid.chaleurVolumiqueKjm3)
  }

  return {
    ...state,
    res_debitNecessaire,
    invalidated: false
  }
}

export default I09DIMCIRC_docalcul
